import { render, staticRenderFns } from "./Containers.vue?vue&type=template&id=31df296e&"
import script from "./Containers.vue?vue&type=script&lang=js&"
export * from "./Containers.vue?vue&type=script&lang=js&"
import style0 from "./Containers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports